<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="600px"
      :fullscreen="isMobileBreakpoint"
      :persistent="isMobileBreakpoint"
    >
      <v-card>
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="renameModalTitle ml-3">
            {{ $t('message.pages.pandaAssist.renameModal.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0 renameModalDescription">
          <v-container class="pl-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" v-on:submit.prevent>
                  <v-textarea
                    v-model="assistant.name"
                    outlined
                    dense
                    :label="$t('message.name')"
                    :rules="[rules.required, rules.maxLength, rules.minLength]"
                    required
                    no-resize
                    counter="255"
                    rows="1"
                    color="primary"
                    @keyup.enter="handleEnter"
                  ></v-textarea>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
          class="px-8 py-6"
          :class="isMobileBreakpoint ? 'mobile-actions' : ''"
        >
          <v-spacer></v-spacer>
          <base-btn
            type="tertiary"
            text
            class="mr-4 px-4"
            :disabled="isFetching"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </base-btn>
          <base-btn
            type="primary"
            large
            min-width="185px"
            @click="handleEdit"
            :loading="isFetching"
            :disabled="!valid || isFetching"
          >
            {{ $t('message.pages.pandaAssist.renameModal.button') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import i18n from '@/translations/lang'
import pandaAssist from '@/services/pandaAssist'

export default {
  name: 'renamePandaAssistModal',
  data: () => ({
    open: false,
    isFetching: false,
    assistant: {
      id: '', // ID do assistente
      name: '', // Nome atual do assistente
    },
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
  },
  watch: {
    open(val) {
      if (val === false) {
        const refForm = this.$refs.form
        refForm && refForm.resetValidation()
        this.$root.$emit('renameModalClosed')
      }
    },
  },
  mounted() {
    this.$root.$on('videoModalRenameAssist', (assistant) => {
      this.assistant.id = assistant.id
      this.assistant.name = assistant.name
      this.open = true
    })
  },
  props: {
    rename: {
      type: String,
      default: '',
    },
  },
  beforeDestroy() {
    this.$root.$off('assistantRenameModalOpen')
    this.$root.$emit('renameModalClosed')
  },
  methods: {
    async handleEdit() {
      if (!this.valid || this.isFetching) return
      this.isFetching = true
      try {
        await pandaAssist.updateAssistantInfo(this.assistant.id, {
          name: this.assistant.name.trim(),
        })
        this.$root.$emit('PandaAssistUpdate')
        this.handleClose()
      } catch (error) {
        console.error('Error renaming assistant:', error)
      } finally {
        this.isFetching = false
      }
    },
    handleClose() {
      this.open = false
    },
    handleEnter() {
      if (this.valid) {
        this.handleEdit()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.renameModalTitle {
  color: varFigma(neutral-20-dark);
  font-size: 18px;
  font-weight: 500;
  line-height: 21.6px; /* 120% */
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--v-background-base);
  z-index: 10;
  padding: 16px;
}
</style>
